import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './background-gradients-wrapper.css';
export function BackgroundGradientsWrapper(props) {
    const { className, children } = props;
    return (_jsxs("div", { className: classNames(styles.wrapper, className), children: [_jsx("div", { className: styles.gradientsWrapper, children: _jsx("div", { className: styles.bottomGradient }) }), children] }));
}
